<template>
  <div class="ipo-wrapper">
    <iframe :src="src" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
import NewStockDialog from '@/components/ipo/NewStockDialog.vue'
export default {
  components: { NewStockDialog },
  data() {
    return {
      dialogShow: false,
      toBeListedList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    src() {
      return this.market === 'hk' ? 'https://tf-fh.szfiu.com/citic-ipo/hk' : 'https://tf-fh.szfiu.com/citic-ipo/us'
    }
  },
  created() {
    this.fetchToBeListedListData()
  },
  methods: {
    showDialog(value) {
      this.dialogShow = value
    },
    async fetchToBeListedListData() {
      const res = await this.$post('https://tf-fh.szfiu.com/ipo_api/makeNew/getToBeListedList')
      this.toBeListedList = res.body ?? []
      if (this.toBeListedList.length) {
        const codeList = this.toBeListedList.map((item) => item.symbol)
        this.fetchOfferingDetails(codeList)
      }
    },
    async fetchOfferingDetails(codeList) {
      const promises = codeList.map((code) => {
        return this.$post('https://tf-fh.szfiu.com/ipo_api/offeringDetails/getOfferingDetails', { code })
      })
      const res = await Promise.allSettled(promises)
      this.offeringDetailsList = res.map((item) => item.value?.body ?? {}) ?? []
      if (this.offeringDetailsList.length) {
        this.dialogShow = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ipo-wrapper {
  height: calc(100vh - 94px);
}
</style>
